import React, { useState } from "react";
import { FiColumns, FiCopy, FiDelete, FiPlus, FiTrash2 } from "react-icons/fi";
import DrawerTutorialButton from "../../../DrawerTutorial/DrawerTutorialButton/DrawerTutorialButton";
import ActionBarButton from "./ActionBarButton/ActionBarButton";
import styles from "./TableActionBar.module.scss";

import { Button, Colors, ConfirmationModal } from "@factorearth/component-library";

interface DeleteConfirmationModalProps {
	colorPalette: Colors;
	handleDelete: () => void;
	rowKey: string;
	checkedRowsLength?: number;
}

const DeleteConfirmationModal = ({ colorPalette, handleDelete, checkedRowsLength }: DeleteConfirmationModalProps) => {
	const [open, setOpen] = useState(false);

	return (
		<div style={{ display: "flex" }}>
			<Button
				icon={<FiTrash2 />}
				colorPalette={colorPalette}
				variant="destructive"
				onClick={() => setOpen(true)}
				disabled={checkedRowsLength === 0}
				key="delete-button-table">
				Delete
			</Button>
			<ConfirmationModal
				colorPalette={colorPalette}
				setOpen={setOpen}
				details="This will permanently delete this table row entry. Are you sure you want to continue?"
				confirmTitle="Delete Table Row Entry"
				handleSubmit={() => {
					handleDelete();
					setOpen(false);
				}}
				open={open}
				canClose
			/>
		</div>
	);
};
interface Props {
	color: any;
	handleSetCardView: () => void;
	rowLoading: boolean;
	duplicateSelectedRows: () => void;
	handleDeleteSelection: () => void;
	handleAddManyRows: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	addManyRowsValue: number | undefined;
	setAddManyRowsValue: (e: number | undefined) => void;
	setupDrawer: (location: string) => void;
	checkedRows: string[];
	loaded: boolean;
}

const TableActionBar = (props: Props) => {
	const {
		addManyRowsValue,
		checkedRows,
		color,
		duplicateSelectedRows,
		handleAddManyRows,
		handleDeleteSelection,
		handleSetCardView,
		loaded,
		rowLoading,
		setAddManyRowsValue,
		setupDrawer,
	} = props;

	return (
		<div className={styles.tableActionWrapper}>
			<DrawerTutorialButton helpColor={color.text.tertiary} location={"table"} setupDrawer={setupDrawer} style={{ border: "0px" }} />
			<div className={styles.seperation_line} style={{ background: color.text.secondary }} />
			<>
				<p className={styles.form_text} style={{ color: color.text.primary }}>
					Rows to add
				</p>
				<input
					style={{ border: `${color.text.secondary} solid 1px`, color: color.text.primary, background: color.background.primary }}
					data-test="table-add-row-count-input"
					className={styles.addManyRows_input}
					onChange={(e) => {
						const parsedVal = e.target.value.replaceAll(/\D/g, "");
						const intVal = parseInt(parsedVal);
						if (isNaN(intVal) || intVal < 1) {
							setAddManyRowsValue(undefined);
						} else {
							setAddManyRowsValue(intVal);
						}
					}}
					onBlur={(e) => {
						const parsedVal = e.target.value.replaceAll(/\D/g, "");
						const intVal = parseInt(parsedVal);
						if (isNaN(intVal) || intVal < 1) {
							setAddManyRowsValue(1);
						} else {
							setAddManyRowsValue(intVal);
						}
					}}
					pattern="[0-9]*"
					inputMode="numeric"
					maxLength={4}
					value={addManyRowsValue}
				/>
				<Button
					colorPalette={color}
					onClick={handleAddManyRows}
					data-test="table-add-row-button"
					variant={"outlined"}
					disabled={rowLoading ? true : false}
					icon={<FiPlus />}>
					Add
				</Button>
				<DeleteConfirmationModal
					key="row-mode-delete-btn"
					handleDelete={handleDeleteSelection}
					rowKey={"multi-delete"}
					colorPalette={color}
					checkedRowsLength={checkedRows.length}
				/>
				<Button
					colorPalette={color}
					onClick={duplicateSelectedRows}
					variant={"outlined"}
					disabled={rowLoading || checkedRows.length === 0 ? true : false}
					icon={<FiCopy />}>
					Duplicate
				</Button>
				<div className={styles.seperation_line} style={{ background: color.text.secondary }} />
			</>
			{/* the button below changes a state that lives in the TableField component and should change the users view between the row and the card views*/}
			<ActionBarButton disabled={!loaded} onClick={handleSetCardView}>
				<span className={styles.react_icon}>
					<FiColumns />
				</span>{" "}
				Card View
			</ActionBarButton>
		</div>
	);
};

export default TableActionBar;
